var map = {
	"./carousel_0.jpg": "06ea",
	"./carousel_1.jpg": "0687",
	"./carousel_2.jpg": "6b32",
	"./carousel_3.jpg": "dd54",
	"./carousel_4.jpg": "f055"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d52";